import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import "./styles.css";
import ModalAlert from "../../common/modal-alert";
import ModalConfirm from "../../common/modal-confirm";
import "moment-timezone";
import Moment from "react-moment";

Moment.globalTimezone = 'America/Sao_Paulo';

class Company extends Component {
  state = {
    load: false,
    documentsToUpload: {},
    companyDocuments: {},
    showAprovacao: true,
    showAprovacaoPeriodic: true,
    sectorId: null,
    erroDelete: false,
    rejectDocument: false,
    expiredDocument: false,
    msgFile: ""
  };

  async componentDidMount() {
    await this.searchDocumentsCompany();
    await this.searchDocumentsToCompany();
  }

  searchDocumentsCompany = async () => {
    const companyDocuments = await api.get(
      `/companies/${localStorage.getItem("CompanyId")}/attachments`
    );
    this.setState({ companyDocuments: companyDocuments.data.rows });
  };

  searchDocumentsToCompany = async () => {
    // Documento tipo 1 = Aguardando Aprovação
    const companyTypeDocuments = await api.get(
      `/company-types/${localStorage.getItem(
        "CompanyTypeId"
      )}/documents?DocumentTypeId=1`
    );

    this.setState({ documentsToUpload: companyTypeDocuments.data.data });
    this.sendApproval();
    this.verifyStatusCompany();
    this.verifyStatusDocuments();
    this.verifyIfHasDocumentExpired();
  };

  verifyDocument = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId === id
    );
    return exist.length > 0 ? exist[0].originalName : "";
  };

  verifyDocumentApplicable = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId === id
    );
    return exist.length > 0 ? exist[0].notapplicable : false;
  };

  verifyDocumentNote = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId === id
    );
    return exist.length > 0 ? exist[0].note : "";
  };

  verifyDocumentExpired = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId === id
    );
   
    if (exist.length > 0) {    
      if (exist.length > 0) {
        if (exist[0].expired) {
          return "Vencido";
        }
        else{
          return  (<Moment format="DD/MM/YYYY"  tz="America/Sao_Paulo"> {exist[0].validityDate}</Moment>);
        }
      }
    }
  };

  displayDateValidate = id => {

    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId == id
    );
    if (exist.length > 0) {
      if (exist[0].expired) {
        return  (<i className="text-danger label label-light-danger m-l-20">Vencido</i>);
      }
      else
      {
        return  (<i className="text-success label label-light-success">{<Moment format="DD/MM/YYYY"  tz="America/Sao_Paulo"> 
          {exist[0].validityDate}
        </Moment>}</i>);       
      }
    }
  };

  verifyIfHasDocumentExpired = () => {
    const exist = this.state.companyDocuments.filter(
      item => item.expired === true
    );
    if (exist.length > 0) {
      if (exist[0].expired) {
        this.setState({ expiredDocument: exist[0].expired });
      }
    }
  };
  isExpired = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId === id
    );
    if (exist.length > 0) {
      return exist[0].expired;
    }
  };
  //Método para setar os documentos como não aplicáveis
  checkDocument = async e => {
    this.setState({ msgFile: "", load: true });

    const data = {
      DocumentId: e.target.value,
      notapplicable:
        e.target.checked !== null && e.target.checked !== false ? true : false
    };

    await api
      .post(`/companies/${localStorage.getItem("CompanyId")}/attachments`, data)
      .then(async response => {
        document.getElementById("modal-alert").click();
        this.setState({
          msgAlert: response.data.msg,
          classText: "text-success",
          load: false
        });
        await this.searchDocumentsCompany();
        await this.searchDocumentsToCompany();
      })
      .catch(err => {
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgAlert: err.response.data.errors[0].msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgAlert: "Erro no envio. Tente novamente!",
            classText: "text-danger"
          });
        }
      });
  };

  uploadDocument = async (e, id) => {
    // Status 4 : Rejeitado
    const rejectedDocument = this.state.companyDocuments.filter(
      item => item.AttachmentStatusId === 4
    );
    if (e.target.files.length > 0) {
      this.setState({ msgFile: "", load: true });

      const formData = new FormData();

      formData.append("attachment", e.target.files[0]);
      formData.append("DocumentId", e.target.id);
      formData.append("notapplicable", false);
      const config = {
        headers: {
          "content-type": "multipart/form-data"
        }
      };

      try {
        console.log("TCL: Company -> uploadDocument -> formData", formData);
        var response = null;
        if (
          rejectedDocument.length > 0 || this.isExpired(id)
            ? (response = await api.patch(
                `/companies/${localStorage.getItem("CompanyId")}/attachments`,
                formData,
                config
              ))
            : (response = await api.post(
                `/companies/${localStorage.getItem("CompanyId")}/attachments`,
                formData,
                config
              ))
        )
          document.getElementById("modal-alert").click();

        this.setState({
          msgAlert: response.data.msg,
          classText: "text-success",
          load: false
        });

        this.searchDocumentsCompany();
        this.searchDocumentsToCompany();
      } catch (err) {
        console.log("TCL: Company -> err", err);
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgAlert: err.response.data.errors[0].msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgAlert: "Erro no envio. Tente novamente!",
            classText: "text-danger"
          });
        }
      }
    }
  };

  verifyDocumentIcon = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId == id
    );
    if (exist.length) {
      const status = exist[0].AttachmentStatusId;
      if (status == 1) {
        return "fa fa-clock-o";
      } else if (status == 2 && this.verifyDocumentExpired(id) !== "Vencido") {
        return "fa fa-check text-success";
      } else if (status == 4 || this.verifyDocumentExpired(id) === "Vencido") {
        return "fa fa-times text-danger";
      }
    } else {
      return "fa fa-circle-thin";
    }
  };

  sendApproval = async () => {
    if (
      this.state.companyDocuments.length >= this.state.documentsToUpload.length
    ) {
      this.setState({ showAprovacao: true });
    } else {
      this.setState({ showAprovacao: false });
    }
  };

  verifyStatusCompany = async e => {
    await api
      .get(`/companies/${localStorage.getItem("CompanyId")}`)
      .then(result => {
        this.setState({
          companyStatus: result.data.data.CompanyStatusId,
          sectorId: result.data.data.SectorId
        });
      });

    try {
      const response = await api.get(
        `/companies?cnpj=${localStorage.getItem("cnpj")}`
      );
      if (response.data.rows.length) {
        let dados = response.data.rows[0];
        this.setState({
          companyStatusDescription: dados.CompanyStatus.description
        });
      }
    } catch (err) {}
  };

  confirmAlterStatusCompany = async e => {
    this.setState({ erroDelete: null });
    document.getElementById("modal-confirm").click();
  };

  alterStatusCompany = async e => {
    this.setState({ load: true });

    const ids = this.state.documentsToUpload.map(doc => doc.id);

    await api
      .patch(`/companies/${localStorage.getItem("CompanyId")}`, {
        // Status da empresa: "Aprovação de documentos da empresa"
        CompanyStatusId: 3,
        SectorId: this.state.sectorId,
        DocumentIds: ids
      })
      .then(result => {
        this.setState({ load: false, erroDelete: null });
        document.getElementById("close-modal-confirm").click();
        document.getElementById("modal-alert").click();
        this.setState({ msgAlert: result.data.msg, classText: "text-success" });
        this.searchDocumentsCompany();
        this.searchDocumentsToCompany();
      })
      .catch(err => {
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgAlert: err.response.data.errors[0].msg,
            classText: "text-danger",
            load: false
          });
        } else {
          this.setState({
            msgAlert: "Erro no envio. Tente novamente!",
            classText: "text-danger",
            load: false
          });
        }
      });
  };

  // Seta no estado caso exista documentos com status: Rejeitado
  verifyStatusDocuments = () => {
    const exist = this.state.companyDocuments.filter(
      item => item.AttachmentStatusId == 4
    );
    this.setState({ rejectDocument: exist.length ? true : false });
  };

  showFileButton = id =>
    this.state.companyStatus === 1 ||
    this.state.companyStatus === 3 ||
    // !this.state.rejectDocument ||
    // this.state.companyStatus === 5 &&
    this.verifyDocumentIcon(id) === "fa fa-check text-success" ||
    this.verifyDocumentIcon(id) === "fa fa-clock-o" ||
    this.verifyDocumentIcon(id) === ""
      ? false
      : true;

  render() {
    return (
      <Fragment>
        <div className="row page-titles">
          <div className="col-md-5 col-8 align-self-center">
            <h3 className="text-themecolor">
              Documentos Cadastrais
              {this.state.load ? <i className="fa fa-spin fa-spinner" /> : null}
            </h3>
          </div>
        </div>
        <form action="javascript:void(0)" id="formDocuments">
          <div
            className={
              this.state.companyStatusDescription === "Habilitado"
                ? "row alert alert-success"
                : "row alert alert-primary"
            }
          >
            <span>
              Status da empresa:
              <strong> {this.state.companyStatusDescription}</strong>
            </span>
          </div>
          <div className="row card">
            <div className="col-md-12">
              <div className="card-body">
                <h4 className="card-title">
                  Envio de documentos para credenciamento da empresa
                  {this.state.load ? (
                    <i className="text-info">
                      {" "}
                      - <i className="fa fa-spin fa-spinner" /> Processando
                      arquivo
                    </i>
                  ) : null}
                </h4>

                <div className="feeds" style={{ overflowX: "hidden" }}>
                  {this.state.documentsToUpload.length
                    ? this.state.documentsToUpload.map(item => {
                        return (
                          <div
                            key={item.id}
                            className={"row align-center"}
                            style={{ padding: "20px", justifyContent: "space-between", alignItems: "center" }}
                          >
                            <i className={this.verifyDocumentIcon(item.id)} />

                            <div className="col-md-3">{item.description}</div>
                            <div className="col-md-2">
                              {this.verifyDocumentNote(item.id) ? (
                                <i className="text-danger label label-light-danger m-l-20">
                                  {this.verifyDocumentNote(item.id)}
                                </i>
                              ) : null}

                            {this.displayDateValidate(item.id)}        
                            </div>

                            <div className="col-md-2">
                              {this.verifyDocument(item.id) ? (
                                <i
                                  alt={this.verifyDocument(item.id)}
                                  title={this.verifyDocument(item.id)}
                                  className={
                                    this.verifyDocument(item.id)
                                      ? "text-success label label-light-success"
                                      : "text-danger"
                                  }
                                >
                                  <i className="fa fa-check" />
                                  {this.verifyDocument(item.id).substr(0, 20) +
                                    "..."}
                                </i>
                              ) : null}
                            </div>

                            <div className="col-md-2">
                              {/* Se status = ("Envio de documentos da empresa" ou
                              "Documentos da empresa rejeitados") e 
                              Não tiver sido aprovado então renderiza o botão */}
                              {this.showFileButton(item.id) ||
                              this.verifyDocumentExpired(item.id) ===
                                "Vencido" ? (
                                <input
                                  style={{ width: "150px" }}
                                  type="file"
                                  id={item.id}
                                  onChange={e =>
                                    this.uploadDocument(e, item.id)
                                  }
                                />
                              ) : null}
                            </div>

                            <div className="col-md-2">
                              {(this.state.companyStatus == 2 ||
                                this.state.companyStatus == 4) &&
                              this.verifyDocumentIcon(item.id) !=
                                "fa fa-check text-success" ? (
                                <div key={item.id} className="text-right p-10">
                                  <input
                                    type="checkbox"
                                    checked={this.verifyDocumentApplicable(
                                      item.id
                                    )}
                                    name="not_applicable"
                                    value={item.id}
                                    id={"document_" + item.id}
                                    onClick={this.checkDocument}
                                  />
                                  <label htmlFor={"document_" + item.id}>
                                    {" "}
                                    Não Aplicável{" "}
                                  </label>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
            <div className="col-md-12 text-center p-20">
              {this.state.documentsToUpload.length &&
                this.state.showAprovacao &&
                (this.state.companyStatus == 2 ||
                  this.state.companyStatus == 4 ||
                  (this.state.companyStatus == 5 &&
                    this.state.expiredDocument)) &&
                !this.state.rejectDocument && (
                  <button
                    className="btn btn-success"
                    onClick={this.confirmAlterStatusCompany}
                  >
                    Enviar para aprovação
                  </button>
                )}

              {this.state.msgFile ? (
                <div className="alert alert-danger">{this.state.msgFile}</div>
              ) : null}

              {!this.state.showAprovacao &&
                (this.state.companyStatus == 2 ||
                  this.state.companyStatus == 4) && (
                  <div className="alert alert-danger">
                    Para enviar os documentos para aprovação é necessário anexar
                    todos os documentos!
                  </div>
                )}

              {this.state.companyStatus == 3 && (
                <div className="alert alert-info">
                  Seus documentos estão em processo de aprovação!
                </div>
              )}
            </div>
          </div>
        </form>

        <ModalConfirm
          title="Confirmação"
          msg="Tem certeza que deseja enviar os documentos para aprovação?"
          load={this.state.load}
          function={this.alterStatusCompany}
          msgError={this.state.erroDelete}
        />
        <ModalAlert
          title="Envio de Documento(s)"
          msg={this.state.msgAlert}
          function=""
          classText={this.state.classText}
        />
      </Fragment>
    );
  }
}

export default Company;
